import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Home.css';
import { LoginButton } from '../components/common/LoginButton';
import ThemeToggle from '../components/ThemeToggle';

const MENU = [
  {
    id: 'local',
    path: '/local',
    icon: '🎮',
    label: 'Gioca in Locale',
    desc: '1 dispositivo, 3 giocatori',
    color: '#FFCC00',
    primary: true,
    guest: true,
  },
  {
    id: 'multiplayer',
    path: '/multiplayer',
    icon: '🌐',
    label: 'Multiplayer',
    desc: '3 dispositivi, 1 stanza',
    color: '#FF8800',
    primary: true,
  },
  {
    id: 'training',
    path: '/training',
    icon: '🏋️',
    label: 'Allenamento',
    desc: 'Top 100/200/500 parole',
    color: '#22C55E',
  },
  {
    id: 'study',
    path: '/study',
    icon: '📖',
    label: 'Studio',
    desc: 'Studia per il tuo ruolo',
    color: '#8B5CF6',
    comingSoon: true,
  },
  {
    id: 'teams',
    path: '/teams',
    icon: '🏆',
    label: 'Squadre',
    desc: 'Il tuo hub di squadra',
    color: '#EC4899',
  },
  {
    id: 'profile',
    path: '/profile',
    icon: '📊',
    label: 'Statistiche',
    desc: 'I tuoi progressi',
    color: '#06B6D4',
  },
];

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();
  const [isLoginOpen, setIsLoginOpen] = useState(
    new URLSearchParams(location.search).get('login') === 'true',
  );

  return (
    <div className="home">
      {/* Header */}
      <header className="home-header">
        <div className="home-header__left">
          <ThemeToggle />
        </div>

        <div className="home-header__center">
          <div className="home-header__logo">
            <span className="home-header__chain">Chain</span>
            <span className="home-header__reaction">Reaction</span>
          </div>
        </div>

        <div className="home-header__right">
          <LoginButton
            className="home-header__login"
            isOpen={isLoginOpen}
            onToggle={setIsLoginOpen}
          >
            Accedi
          </LoginButton>
        </div>
      </header>

      {/* Main grid */}
      <main className="home-main">
        {/* Primary CTA cards */}
        <div className="home-primary-row">
          {MENU.filter((m) => m.primary).map((m) => {
            const isLocked = m.comingSoon || (!currentUser && !m.guest);
            return (
              <button
                key={m.id}
                className={`home-card home-card--primary ${isLocked ? 'home-card--locked' : ''}`}
                style={{ '--card-color': m.color }}
                onClick={() => !isLocked && navigate(m.path)}
                id={`btn-home-${m.id}`}
              >
                {isLocked ? (
                  <div className="home-card__lock-overlay">
                    <span className="home-card__lock-text">
                      {!currentUser && !m.guest ? 'Accesso richiesto' : 'Coming Soon'}
                    </span>
                  </div>
                ) : null}
                <span className="home-card__icon">{m.icon}</span>
                <div className="home-card__text">
                  <h2 className="home-card__label">{m.label}</h2>
                  <p className="home-card__desc">{m.desc}</p>
                </div>
              </button>
            );
          })}
        </div>

        {/* Secondary grid */}
        <div className="home-secondary-grid">
          {MENU.filter((m) => !m.primary).map((m) => {
            const isLocked = m.comingSoon || (!currentUser && !m.guest);
            return (
              <button
                key={m.id}
                className={`home-card home-card--secondary ${isLocked ? 'home-card--locked' : ''}`}
                style={{ '--card-color': m.color }}
                onClick={() => !isLocked && navigate(m.path)}
                id={`btn-home-${m.id}`}
              >
                {isLocked ? (
                  <div className="home-card__lock-overlay">
                    <span className="home-card__lock-text">
                      {!currentUser && !m.guest ? 'Accesso richiesto' : 'Coming Soon'}
                    </span>
                  </div>
                ) : null}
                <span className="home-card__icon">{m.icon}</span>
                <h2 className="home-card__label">{m.label}</h2>
                <p className="home-card__desc">{m.desc}</p>
              </button>
            );
          })}
        </div>
      </main>
    </div>
  );
};

export default Home;
